<template>
  <div class="flex-col gap-3">
    <!-- Sub-heading slot -->
    <div
      v-if="$slots['sub-heading']"
      class="own-table-card-renderer__sub-heading"
    >
      <slot name="sub-heading" />
    </div>

    <template v-if="$slots['no-data'] && !hasItems">
      <slot name="no-data" />
    </template>

    <!-- Cards container -->
    <div ref="reorderableList" class="flex-col gap-3">
      <!-- @vue-expect-error key should be part of item -->
      <OwnOption
        v-for="(item, index) of props.items"
        :key="item[itemKey]"
        @click="emit('click', item)"
      >
        <div class="flex-row gap-4 align-start w-full">
          <DragHandle v-if="props.reorderable" />
          <slot name="card" :item="item" :row-idx="index" />
        </div>
      </OwnOption>
    </div>
  </div>
</template>

<script lang="ts" setup generic="T extends Record<string, unknown>">
import Sortable, { SortableEvent } from 'sortablejs'
import { computed, onMounted, ref } from 'vue'

import { ReorderEvent } from '@/utils/helpers/reorder'

import { OwnOption } from '../../OwnOption'
import DragHandle from '../../reorderable/DragHandle.vue'

const props = defineProps<{
  hasClick: boolean
  items: T[]
  itemKey: string
  reorderable: boolean
}>()

const emit = defineEmits<{
  (event: 'click', value: T): void
  (event: 'reorder', value: ReorderEvent): void
}>()

const reorderableList = ref<HTMLDivElement | null>(null)

const hasItems = computed(() => {
  return props.items.length > 0
})

onMounted(() => {
  if (props.reorderable && reorderableList.value) {
    Sortable.create(reorderableList.value, {
      animation: 150,
      direction: 'vertical',
      handle: '.drag-handle',
      onEnd: ({ oldIndex, newIndex }: SortableEvent) => {
        if (oldIndex === newIndex) return
        emit('reorder', { newIndex, oldIndex } as ReorderEvent)
      },
    })
  }
})
</script>

<style lang="scss" scoped>
.own-table-card-renderer__sub-heading {
  margin-bottom: 8px;
}
</style>
